/** @format */

import {
  createAsyncThunk,
  createEntityAdapter,
  createSlice,
} from "@reduxjs/toolkit";
import axios from "axios";

export const getLocation = createAsyncThunk(
  "location/getLocation",
  async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/v1/api/cms/public/location`,
        {
          params: {
            page: 1,
            limit: 10,
            sort: "desc",
            by: "def.created_at_branch",
            search: "",
          },
        },
      );
      console.log("respon location", response.data);
      return response.data.data;
    } catch (error) {
      console.error("Error fetching location:", error);
      throw error;
    }
  },
);

const locationEntity = createEntityAdapter({
  selectId: (location) => location.id_branch,
});

const locationSlice = createSlice({
  name: "location",
  initialState: locationEntity.getInitialState(),
  extraReducers: {
    [getLocation.fulfilled]: (state, action) => {
      locationEntity.setAll(state, action.payload);
    },
  },
});

export const locationSelector = locationEntity.getSelectors(
  (state) => state.location,
);
export default locationSlice.reducer;
